import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':fieldReportId'}/workSummaryStatus`;

export const ROUTE: RouteDefinition = `${baseRoute}/:fieldReportId/workSummaryStatus`;

export const URL = (fieldReportId: number): RouteDefinition =>
	`${baseRoute}/${fieldReportId}/workSummaryStatus`;
